import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Portfolio from '@/components/Portfolio'
import PortfolioWork from '@/components/PortfolioWork'
import Atelier from '@/components/Atelier'
import Interferencias from '@/components/Interferencias'
import Registos from '@/components/Registos'
import Contactos from '@/components/Contactos'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: Portfolio
    },
    {
      path: '/portfolio/:uid',
      name: 'PortfolioWork',
      component: PortfolioWork,
      props: {
        categoria: ':categoria'
      }
    },
    {
      path: '/atelier',
      name: 'Atelier',
      component: Atelier
    },
    {
      path: '/interferencias',
      name: 'Interferencias',
      component: Interferencias
    },
    {
      path: '/registos',
      name: 'Registos',
      component: Registos
    },
    {
      path: '/contactos',
      name: 'Contactos',
      component: Contactos
    }
  ]
})
